"use strict";

import { TASK_STATUS } from "./taskStatuses.js";
import { formatRequestTime } from "./videoIngestion.js";

// The merge job marks the remux running only once it starts, 30 seconds to a
// few minutes after the request. Until then the status poll keeps showing the
// previous run's status, which would let a second click start a second run.
// A request blocks Re-remux until its job reports running, or until this long
// has passed without it starting, so a lost request can be sent again.
export const REMUX_START_TIMEOUT_MS = 5 * 60 * 1000;

export const recordRemuxRequest = (language, requestedAt = new Date()) => ({
    language,
    requestedAt,
});

// The request still waiting for its job to start, or null.
export const getPendingRemuxRequest = (request, mergingStatus, now = Date.now()) => {
    if (!request || mergingStatus === TASK_STATUS.inProgress) {
        return null;
    }
    return now - request.requestedAt.getTime() < REMUX_START_TIMEOUT_MS ? request : null;
};

// Why Re-remux is disabled while a request waits to start, or null.
export const remuxRequestBlocker = (
    request,
    mergingStatus,
    languageName = (language) => language,
    now = new Date()
) => {
    const pending = getPendingRemuxRequest(request, mergingStatus, now.getTime());
    if (!pending) {
        return null;
    }
    return `A remux for ${languageName(pending.language)} was requested at ${formatRequestTime(
        pending.requestedAt,
        now
    )}. Wait for it to start.`;
};
